import React from "react";
import { money } from "@/lib/financeApi";
import ObligationContent from "@/components/nds/windows/finance/ObligationContent";

const CFG = {
  key: "rent_roll", api: "/rent-roll", testid: "fin-rent", label: "Rent", refType: "rent_roll", summaryTone: "red",
  summaryText: (s) => `${s.overdue_count} overdue · ${money(s.overdue_balance)}`,
};

export default function FinRentRollContent() {
  return <ObligationContent cfg={CFG} />;
}
